import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
		<p>
			Nia malgranda komunumo, ŝajne, komencas poiomete klariĝi. 
			Ho ne, mi ne asertas, ke antaŭe la vicojn de esperantistoj konsistigis plejparte …hmmm… stranguloj. 
			Mi temas nur pri tre maldika tavolo de intelektuloj, kiuj scipovas legi kaj aĉetas librojn ne por «subteni nian Esperantan eldonadon», sed simple por havi plezuron de bona legado.
		</p>
		
		<p>
			Sed natura emo de homo estas ja dividi sian plezuron kun proksimuloj. 
			Do, jen bona novaĵo por tiaj homoj: vi povas legi bonajn librojn en Esperanto, kaj poste, en bona kompanio pasigi agrablan vesperon, ludante novan surtablan ludon «TALISMANOJ». 
			Tiu 54-peca kolora kartaro estas eldonita en 2012 kun dezajno de Abel Montagut. 
			Duono de la kartoj surhavas citaĵojn el «Don Quijote», kaj duono – el «Verdaj Donkiĥotoj», t.e. nuntempaj esperantaj verkistoj, multaj el Ibera Skolo, sed ne nur. 
			Sur ĉiu karto de «Don Quijote» estas pritema bildo de Gustave Dore kaj la citaĵo. 
			Sur la kartoj de «Verdaj Donkiĥotoj» troviĝas portretoj de niaj verkistoj kaj citaĵoj el iliaj verkoj. 
			Belaspektajn kartojn agrablas vidi, - kaj ege utilas ankaŭ legi la citaĵojn kaj almenaŭ tiamaniere plivastigi siajn sciojn pri nia literaturo kaj eĉ tutmonda kulturo.
		</p>
		
		<p>
			Ludante, oni (re)legas la citaĵojn el la trezoro de la monda literaturo («Don Quijote»), kaj el la trezorejo de nia, ne tiom abunda, tamen vast-monda literaturo. 
			Kaj ankaŭ oni (re)ĝuas la senmortajn ilustraĵojn al la ĉefverko, kaj konatiĝos kun vizaĝoj de niaj literaturistoj. 
			Tiel nia literaturo, nia kulturo fariĝos pli proksimaj al ni.
		</p>
		
		<p>
			La nuntempaj verkistoj, cititaj en la ludo, reprezentas plejparte la t.n. 
			Iberan Skolon. Estas bonege, ke en la nuntempa «globaligita» mondo, iu ne-anglosaksa nacio prezentas sin kaj sian kulturan heredaĵon. 
			Estas imitinda afero, kaj ni atendus de aliuj kulturaj kaj artaj rondoj de esperantistoj pli bravan elmontron de siaj nunaj kaj antaŭaj atingoj. 
		</p>
		`
	)
}

const itemName = {
	esp: 'Pri «Talismanoj»'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp,
	}
}

export default item;